import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Navigation } from 'swiper'

import { CourseCard } from 'components/CourseType/CourseCard'

import 'swiper/css'
import 'swiper/css/free-mode'

import Grid from '@mui/material/Grid'

export const RecommendationSlider = ({ courses }: any): JSX.Element => {
  return (
    <Grid sx={{ ml: { xs: '0px', md: '-20px' } }}>
      {Array.isArray(courses) && (
        <Swiper
          freeMode={true}
          navigation={true}
          modules={[FreeMode, Navigation]}
          className="mySwiper custom-slide"
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            450: {
              slidesPerView: 1.1,
            },
            480: {
              slidesPerView: 1.2,
            },
            540: {
              slidesPerView: 1.5,
            },
            640: {
              slidesPerView: 1.7,
            },
            720: {
              slidesPerView: 1.7,
            },
            860: {
              slidesPerView: 2.1,
            },
            920: {
              slidesPerView: 2.2,
            },
            1100: {
              slidesPerView: 2.8,
            },
            1200: {
              slidesPerView: 2.5,
            },
            1280: {
              slidesPerView: 3,
            },
            1350: {
              slidesPerView: 3.4,
            },
            1550: {
              slidesPerView: 3.6,
            },
            1750: {
              slidesPerView: 4.3,
            },
          }}
        >
          {courses.map((item, index: number) => {
            return (
              <SwiperSlide key={index} className="custom-slide">
                <Grid sx={{ m: '20px' }}>
                  <CourseCard courseTypes={item} />
                </Grid>
              </SwiperSlide>
            )
          })}
        </Swiper>
      )}
    </Grid>
  )
}
